<template>
  <b-modal
    title="Информация"
    ref="modal"
    :hide-footer="!showReload"
    @ok="onReload"
  >
    <div v-html="maintenanceMessage" />
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary">Перезагрузить сейчас</b-button>
      <b-button @click="cancel" variant="secondary">Отмена</b-button>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import { BModal } from 'bootstrap-vue'
import { notificationsMapper } from '@/store/modules/notifications'
import { MaintenanceInfo } from 'interfaces/notifications'

const Mappers = Vue.extend({
  computed: {
    ...notificationsMapper.mapState(['maintenanceInfo'])
  }
})

@Component
export default class MaintenanceModal extends Mappers {
  $refs!: { modal: BModal }
  private maintenanceMessage = ''
  private showReload = false

  @Watch('maintenanceInfo', { deep: true })
  private onMaintenanceUpdate(data: MaintenanceInfo | null) {
    if (data) {
      this.maintenanceMessage = data.message
      this.showReload = data.showReload ?? false
      if (_.isEmpty(data.time) || moment().isSameOrBefore(moment(data.time))) {
        this.$refs.modal.show()
      }
    }
  }

  private onReload() {
    location.reload()
  }
}
</script>
